import React, { useState } from "react";
import { FaEnvelope, FaPhone, FaHome } from "react-icons/fa";
import { Helmet } from "react-helmet";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowModal(true);
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      message: "",
    });
    setTimeout(() => setShowModal(false), 3000);
  };

  return (
    <>
      <Helmet>
        <title>Neralen - Ζαχαροπλαστική Τέχνη</title>
        <meta
          name="description"
          content="Neralen - Ανακαλύψτε τον κόσμο της ζαχαροπλαστικής τέχνης με αυθεντικές συνταγές και επαγγελματικές συμβουλές"
        />
      </Helmet>

      <div className="contact-container">
        <div className="about-hero">
          <h1>Επικοινωνήστε Μαζί Μας</h1>
          <p>
            Είμαστε εδώ για να απαντήσουμε στις ερωτήσεις σας και να σας
            βοηθήσουμε στο ταξίδι σας στον κόσμο της ζαχαροπλαστικής. Μη
            διστάσετε να επικοινωνήσετε μαζί μας!
          </p>
        </div>

        <div className="contact-grid">
          <div className="contact-info">
            <h2>Στοιχεία Επικοινωνίας</h2>

            <div className="contact-item">
              <div className="contact-icon">
                <FaHome />
              </div>
              <div className="contact-details">
                <h3>Διεύθυνση</h3>
                <p>
                  Armatolon ke Klefton 48
                  <br />
                  114 71, Αμπελόκηποι
                  <br />
                  Greece
                </p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <FaPhone />
              </div>
              <div className="contact-details">
                <h3>Τηλέφωνο</h3>
                <p>+302130281863</p>
                <p>Δευτέρα - Παρασκευή: 09:00 - 18:00</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <FaEnvelope />
              </div>
              <div className="contact-details">
                <h3>Email</h3>
                <p>
                  <a href="mailto:neralen@hotmail.com">neralen@hotmail.com</a>
                </p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-details">
                <h3>ΑΦΜ</h3>
                <p>23031216</p>
              </div>
            </div>
          </div>

          <div className="contact-form">
            <h2>Στείλτε μας Μήνυμα</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="firstName">Όνομα *</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="lastName">Επώνυμο *</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  pattern="[^@]+@[^@]+\.[a-zA-Z]{2,6}"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Τηλέφωνο *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  pattern="^\+?[0-9]{9,15}$"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Μήνυμα *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-btn">
                Αποστολή Μηνύματος
              </button>
            </form>
          </div>
        </div>

        {showModal && (
          <div className="modal">
            <div className="modal-content">
              <h2>Ευχαριστούμε!</h2>
              <p>
                Το μήνυμά σας στάλθηκε επιτυχώς. Θα επικοινωνήσουμε μαζί σας το
                συντομότερο δυνατό!
              </p>
              <button
                onClick={() => setShowModal(false)}
                className="modal-close"
              >
                Εντάξει
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Contact;
